module.exports = __webpack_public_path__ + "static/media/rodrigo-profile.b5e4b64c.jpeg";